<template>
  <b-container>
    <b-alert v-model="showErrorStatusChange" placement="top" duration="3000" type="danger" width="400px" dismissable>
      <span class="icon-info-circled alert-icon-float-left"></span>
      <strong>{{ $t('LNG_ERROR', this.lang) }}</strong>
      <p>{{ $t('LNG_STATUS_WAS_NOT_CHANGED', this.lang) }}</p>
    </b-alert>
    
    <b-row>
      <b-col cols="12">
        <h3>{{ $t('LNG_CENTER_MANAGEMENT_TITLE', this.lang) }}</h3>
      </b-col>
    </b-row>
    
    <b-row>
      <b-col cols="12">
        <v-client-table ref="centerTable" :data="centersData" :columns="centersColumns" :options="centersOptions">
          <div slot="status" slot-scope="props" class="fa" v-bind:class="{'fa-minus-circle': props.row.status === '1', 'fa-check-circle': props.row.status === '0'}" v-on:click="changeStatus(props.row.id)" style="cursor: pointer;"></div>
          <div slot="editCenter" slot-scope="props" class="fa fa-edit" v-on:click="centerRowClick(props)" style="cursor: pointer;"></div>
       </v-client-table>
      </b-col>
    </b-row>
    <b-modal v-model="newCenterModal" effect="fade" :title="$t('LNG_NEW_CENTER', this.lang)" @shown="setModalInputFocus">
        <div class="alert alert-danger" role="alert" v-if="showCenterUpdateError">
           {{ this.updateCenterErrorMessage }}
        </div>
        <b-input ref="centerName" v-model="centerName" type="text" required :placeholder="$t('LNG_NAME_CENTER', this.lang)" class="mb-3"/>
        <b-input ref="grade" v-model="grade" type="number" required :placeholder="$t('LNG_MAX_GRADE', this.lang)"/>
        <div slot="modal-footer">
           <b-button type="button" v-on:click.prevent="exitNewCenterModal()">{{ $t('LNG_CLOSE', lang) }}</b-button>
           <b-button variant="evaobj" type="button" v-on:click.prevent="createUpdateNewCenter($event)">{{ btnSaveText }}</b-button>
        </div>
     </b-modal>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'managementCenter',
  components: {
  },
  data () {
    return {
      showErrorStatusChange: false,
      showCenterUpdateError: false,
      updateCenterErrorMessage: '',
      centerName: '',
      newCenterModal: false,
      selectedCenter: 0,
      centersData: [],
      centersColumns: ['name', 'grade', 'status', 'editCenter'],
      centersOptions: {
        headings: {
          name: this.$t('LNG_NAME_CENTER', this.lang),
          grade: this.$t('LNG_MAX_GRADE', this.lang),
          status: this.$t('LNG_STATUS', this.lang),
          editCenter: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name'],
        sortable: ['name', 'status']
      },
      btnSaveText: this.$t('LNG_CREATE', this.lang),
      grade: 6
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadCenters()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
    setModalInputFocus (event) {
      this.$refs.centerName.focus()
    },
    back: function () {
      this.$router.push({ path: '/' })
    },
    loadCenters: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadCenters'
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.centersData = response.data.centers
      })
    },
    changeStatus: function (itemId) {
      this.showErrorStatusChange = false
      var newStatus
      this.centersData.forEach(function (center) {
        if (center.id === itemId) {
          if (center.status === '1') {
            newStatus = '0'
          } else {
            newStatus = '1'
          }
        }
      })

      // Change the status in the db
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setCenterStatus',
          status: newStatus,
          centerId: itemId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.centersData.forEach(function (center) {
            if (center.id === itemId) {
              center.status = newStatus
            }
          })
        } else {
          this.showErrorStatusChange = true
        }
      })
    },
    addCenter: function () {
      this.showCenterUpdateError = false
      this.selectedCenter = 0
      this.grade = 6
      this.btnSaveText = this.$t('LNG_CREATE', this.lang)
      this.newCenterModal = true
    },
    exitNewCenterModal: function () {
      this.newCenterModal = false
      this.showCenterUpdateError = false
      this.centerName = ''
      this.selectedCenter = 0
    },
    createUpdateNewCenter: function (data) {
      this.showCenterUpdateError = false
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createUpdateCenter',
          name: this.centerName,
          grade: this.grade,
          id: this.selectedCenter
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        if (response.data.status === 'OK') {
          this.newCenterModal = false
          this.centerName = ''
          this.selectedCenter = 0
          this.loadCenters()
        } else {
          this.updateCenterErrorMessage = this.$t(response.data.error, this.lang)
          this.showCenterUpdateError = true
        }
      })
    },
    centerRowClick: function (data) {
      this.selectedCenter = data.row.id
      this.centerName = data.row.name
      this.grade = data.row.grade
      this.showCenterUpdateError = false
      this.btnSaveText = this.$t('LNG_SAVE', this.lang)
      this.newCenterModal = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// managementCenter.vue?c994b712